
import $ from "jquery"
import log from "plugins/loglevel"


// Remeber, BOTH the trigger and target can be multiple
// but trigger is singular in event listener

// Required data attribute, either one of them
const TARGET_DATA_ATTR_NAME = "toggleable-target" // use this to search globally
const TARGET_IN_CHILDREN_DATA_ATTR_NAME = "toggleable-child" // use this to search for target in children
const TARGET_IN_PARENTS_DATA_ATTR_NAME = "toggleable-parent" // use this to search for target in parents
// This is for TRIGGER, optional
const TRIGGER_ONEOFF_SWITCH_DATA_ATTR_NAME = "toggleable-trigger-oneoff"
// No need to add this attribute
const TRIGGER_ONEOFF_PROCESSED_DATA_ATTR_NAME = "toggleable-trigger-oneoff-processed"
// This is for TARGET, optional
const TARGET_ONEOFF_SWITCH_DATA_ATTR_NAME = "toggleable-target-oneoff"
// No need to add this attribute
const TARGET_ONEOFF_PROCESSED_DATA_ATTR_NAME = "toggleable-target-oneoff-processed"

const SELECTOR = `[data-${TARGET_DATA_ATTR_NAME}], [data-${TARGET_IN_CHILDREN_DATA_ATTR_NAME}], [data-${TARGET_IN_PARENTS_DATA_ATTR_NAME}] `

// Use this class for styling
const TARGET_TOGGLED_CLASS = "with-js-state-toggled"

const INIT_DONE_CLASS_NAME = "js--data-toggleable-triggers-and-targets--init-done"



const get_$targets = ($trigger: JQuery): JQuery => {
  if ($trigger.data(TARGET_DATA_ATTR_NAME) != null) {
    return $($trigger.data(TARGET_DATA_ATTR_NAME))
  }
  else if ($trigger.data(TARGET_IN_CHILDREN_DATA_ATTR_NAME) != null) {
    return $trigger.find($trigger.data(TARGET_IN_CHILDREN_DATA_ATTR_NAME))
  }
  else if ($trigger.data(TARGET_IN_PARENTS_DATA_ATTR_NAME) != null) {
    return $trigger.parents($trigger.data(TARGET_IN_PARENTS_DATA_ATTR_NAME))
  }
  else {
    log.error(`Element ${$trigger.toString()} has no neither of 3 attributes, selector might be incorrect`)
    return $()
  }
}


// === Hide toggle target on start or after AJAX ===
function initOneElement(trigger: Element): void {
  const $trigger = $(trigger)

  if ($trigger.hasClass(INIT_DONE_CLASS_NAME)) {
    return
  }
  else {
    $trigger.addClass(INIT_DONE_CLASS_NAME)
  }

  $trigger.on("click", (e) => {
    const is_oneoff_trigger = ($trigger.data(TRIGGER_ONEOFF_SWITCH_DATA_ATTR_NAME) != null)

    // if trigger is a one off trigger and already processed, ignore
    if (is_oneoff_trigger && ($trigger.data(TRIGGER_ONEOFF_PROCESSED_DATA_ATTR_NAME) != null)) {
      return
    }

    if (is_oneoff_trigger) {
      $trigger.data(TRIGGER_ONEOFF_PROCESSED_DATA_ATTR_NAME, true)
    }

    const $targets = get_$targets($trigger)

    if ($targets.length === 0) {
      return
    }

    $targets.each((_idx, element) => {
      const $target = $(element)

      const is_oneoff_target = ($target.data(TARGET_ONEOFF_SWITCH_DATA_ATTR_NAME) != null)

      // if trigger is a one off trigger and already processed, ignore
      if (is_oneoff_target && ($target.data(TARGET_ONEOFF_PROCESSED_DATA_ATTR_NAME) != null)) {
        return
      }

      if (is_oneoff_target) {
        $target.data(TARGET_ONEOFF_PROCESSED_DATA_ATTR_NAME, true)
      }

      $target.toggleClass(TARGET_TOGGLED_CLASS)
    })

    e.preventDefault()
  })
}



const onLoad = () => {
  // On document ready
  $(SELECTOR).each((_idx, element) => {
    initOneElement(element)
  })

  // On AJAX success
  $(document).ajaxSuccess(() => {
    $(SELECTOR).each((_idx, element) => {
      initOneElement(element)
    })
  })
}


export default {
  onLoad: onLoad,
}
